import React from 'react';
import SummaryCard from './SummaryCard';
import { formatCurrency } from '../utils/formatters';

const icons = {
    'Term Insurance': '🛡️',
    'Critical Illness Cover': '💊',
    'Will & Testament': '📜',
    'Nominee Details': '👤',
    'Property documents and loan papers': '🏠',
    'Insurance policies with policy numbers': '🛡️',
    'Will and trust details': '📜',
    'Investment account details': '💼',
    'Bank account details': '🏦',
    'Login Credentials (Sealed)': '🔒',
};

function ContingencyPlanning({ data, insuranceData }) {
    return (
        <SummaryCard title="Contingency Planning">
            <div className="mb-4">
                <p className="content-text text-gray-500">
                    Certain things can be unknown/unplanned in life!
                </p>
            </div>

            {/* Debt Free Section */}
            <div className="mb-6">
                <h4 className="content-text text-gray-900 font-medium mb-4">
                    Make sure your <span className="font-bold">family stays debt free</span>
                </h4>

                <div className="space-y-3">
                    {insuranceData.insurance_metrics?.map((item, idx) => (
                        <div key={item.insurance_type} className="flex items-start justify-between gap-4">
                            <div className="flex items-start gap-3 flex-1">
                                <span className="text-purple-500 text-lg mt-0.5">
                                    {icons[item.insurance_type] || '🛡️'}
                                </span>
                                <div className="flex-1">
                                    <h5 className="content-text font-medium text-gray-800 mb-1">
                                        {item.insurance_type}
                                    </h5>
                                    <p className="content-text text-gray-600 text-sm">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="content-text text-gray-500 text-sm mb-1">Coverage</p>
                                <p className="content-text font-medium text-gray-800">
                                    {formatCurrency(item.coverage)}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Border separator */}
            <div className="border-b border-gray-200 my-6"></div>

            {/* Secure Assets Section */}
            <div className="mb-6">
                <h4 className="content-text text-gray-900 font-medium mb-4">
                    Secure assets for <span className="font-bold">loved ones</span>
                </h4>

                <div className="space-y-4">
                    {data.secureAssets?.map((item, idx) => (
                        <div key={item.type} className="flex items-start gap-3">
                            <span className="text-purple-500 text-lg mt-0.5">
                                {icons[item.type] || '📜'}
                            </span>
                            <div className="flex-1">
                                <h5 className="content-text font-medium text-gray-800 mb-1">
                                    {item.type}
                                </h5>
                                <p className="content-text text-gray-600 text-sm leading-relaxed">
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Border separator */}
            <div className="border-b border-gray-200 my-6"></div>

            {/* Collect Documents Section */}
            <div>
                <h4 className="content-text text-gray-900 font-medium mb-3">
                    Collect necessary documents
                </h4>

                <p className="content-text text-gray-600 text-sm mb-4 leading-relaxed">
                    Assemble the mentioned documents<br />
                    at one place and inform your family members
                </p>

                <div className="space-y-3">
                    {data.documents?.map((doc, idx) => (
                        <div key={doc} className="flex items-center gap-3">
                            <span className="text-purple-500 text-lg">
                                {icons[doc] || '📄'}
                            </span>
                            <span className="content-text text-gray-700">
                                {doc}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </SummaryCard>
    );
}

export default ContingencyPlanning;